import Animation from './core';

export default class SlideAnime extends Animation {
  constructor(ele, options) {
    super(ele, options);
  }

  reverse(speed = 0) {
    if (this.__tween) {
      this.__tween.kill();
    }
    super.reverse(speed);
  }

  addTimeline() {
    this.isiOS = this.options.deviceType.indexOf('ios') > -1;

    this._screenshot = this.getElement('.screenshot');
    this._obj0 = this.getElement('.obj_0');
    this._obj1 = this.getElement('.obj_1');
    this._obj2 = this.getElement('.obj_2');
    this._obj3 = this.getElement('.obj_3');
    this._obj4 = this.getElement('.obj_4');

    switch (this.options.index) {
      case 0:
        this.addTimelineType1();
        break;
      case 1:
        this.addTimelineType2();
        break;
      case 2:
        this.addTimelineType3();
        break;
      case 3:
        this.addTimelineType4();
        break;
    }
  }

  addTimelineType1() {
    this._tl.set(this._screenshot, { y: '200%' });

    if (this.isiOS) {
      this._tl.set(this._obj0, { y: 60 });
    } else {
      this._tl.set(this._obj0, { z: -50, rotationY: 90, transformPerspective: 200 });
    }
    this._tl.set(this._obj1, { y: 50 });
    this._tl.set(this._obj2, { x: 60 });
    this._tl.set(this._obj3, { y: 60 });

    this._tl.to(this._screenshot, 0.6, { y: '0%', opacity: 1, ease: Quad.easeOut });
    if (this.isiOS) {
      this._tl.to(this._obj0, 0.6, { opacity: 1, y: 0, ease: Expo.easeOut }, 0.4);
    } else {
      this._tl.to(this._obj0, 0.6, { opacity: 1, z: 0, rotationY: 0, ease: Expo.easeOut }, 0.4);
    }
    this._tl.to(this._obj1, 0.8, { opacity: 1, z: 0, y: 0, ease: Expo.easeOut }, 0.6);
    this._tl.to(this._obj2, 0.8, { opacity: 1, x: 0, ease: Power2.easeOut }, 0.8);
    this._tl.to(this._obj3, 0.8, { opacity: 1, y: 0, ease: Power2.easeOut }, 1);
  }

  addTimelineType2() {
    this._tl.set(this._screenshot, { y: '200%' });

    this._tl.set(this._obj0, { y: 100 });
    if (this.isiOS) {
      this._tl.set(this._obj1, { y: 50, scale: 0 });
    } else {
      this._tl.set(this._obj1, { x: -100, y: 50, z: -150, transformPerspective: 200 });
    }
    this._tl.set(this._obj2, { scale: 0 });

    this._tl.to(this._screenshot, 0.6, { y: '0%', opacity: 1, ease: Quad.easeOut });

    this._tl.to(this._obj0, 0.4, { opacity: 1, y: 0, ease: Quad.easeOut }, 0.4);
    if (this.isiOS) {
      this._tl.to(this._obj1, 0.6, { opacity: 1, scale: 1, y: 0, ease: Expo.easeOut }, 0.8);
    } else {
      this._tl.to(this._obj1, 0.6, { opacity: 1, x: 0, y: 0, z: 0, ease: Expo.easeOut }, 0.8);
    }
    this._tl.to(this._obj2, 0.6, { opacity: 1, scale: 1, ease: Power3.easeOut }, 1);
    this._tl.call(() => {
      this.__tween = TweenMax.to(this._obj2, 0.4, { opacity: 0.2, repeat: 3, yoyo: true, ease: Linear.easeNone });
    });
  }

  addTimelineType3() {
    this._tl.set(this._screenshot, { y: '200%' });

    this._tl.set(this._obj0, { x: 100 });
    this._tl.set(this._obj1, { y: 150 });
    if (this.isiOS) {
      this._tl.set(this._obj2, { y: 60 });
    } else {
      this._tl.set(this._obj2, { z: -100, rotationY: 90, transformPerspective: 300 });
    }

    // box-shadow: -6px 18px 30px 0 rgba(0, 0, 0, 0.4);
    this._tl.to(this._screenshot, 0.6, { y: '0%', opacity: 1, ease: Quad.easeOut });

    this._tl.to(this._obj0, 0.6, { opacity: 1, x: 0, ease: Quad.easeInOut }, 0.3);
    this._tl.to(this._obj1, 0.8, { opacity: 1, y: 0, ease: Expo.easeOut }, 0.6);
    if (this.isiOS) {
      this._tl.to(this._obj2, 0.6, { opacity: 1, y: 0, ease: Back.easeOut }, 0.8);
    } else {
      this._tl.to(this._obj2, 0.8, { opacity: 1, z: 0, rotationY: 0, ease: Back.easeOut }, 0.8);
    }
  }

  addTimelineType4() {
    this._tl.set(this._screenshot, { y: '200%' });

    this._tl.set(this._obj0, { scale: 0 });
    if (this.isiOS) {
      this._tl.set(this._obj1, { x: -100 });
      this._tl.set(this._obj2, { x: 100 });
      this._tl.set(this._obj3, { x: -100 });
      this._tl.set(this._obj4, { y: 20 });
    } else {
      this._tl.set(this._obj1, { x: -100, rotationY: -90, transformPerspective: 300 });
      this._tl.set(this._obj2, { x: 100, rotationY: 90, transformPerspective: 300 });
      this._tl.set(this._obj3, { x: -100, rotationY: -90, transformPerspective: 500 });
      this._tl.set(this._obj4, { y: 30, transformPerspective: 500 });
    }

    // box-shadow: -6px 18px 30px 0 rgba(0, 0, 0, 0.4);
    this._tl.to(this._screenshot, 0.6, { y: '0%', opacity: 1, ease: Quad.easeOut });

    this._tl.to(this._obj0, 0.6, { opacity: 1, scale: 1, ease: Back.easeInOut }, 0.3);
    if (this.isiOS) {
      this._tl.to(this._obj1, 0.8, { opacity: 1, x: 0, ease: Expo.easeOut }, 0.6);
      this._tl.to(this._obj2, 0.6, { opacity: 1, x: 0, ease: Back.easeOut }, 0.8);
      this._tl.to(this._obj3, 0.6, { opacity: 1, x: 0, ease: Back.easeOut }, 0.8);
      this._tl.to(this._obj4, 0.4, { opacity: 1, y: 0, ease: Quad.easeOut }, 0.9);
    } else {
      this._tl.to(this._obj1, 0.8, { opacity: 1, x: 0, rotationY: 0, ease: Expo.easeOut }, 0.6);
      this._tl.to(this._obj2, 0.6, { opacity: 1, x: 0, rotationY: 0, ease: Back.easeOut }, 0.8);
      this._tl.to(this._obj3, 0.6, { opacity: 1, x: 0, rotationY: 0, ease: Back.easeOut }, 0.8);
      this._tl.to(this._obj4, 0.4, { opacity: 1, y: 0, ease: Quad.easeOut }, 0.9);
    }
  }
}
